module.exports = __webpack_public_path__ + "static/img/service-8.2d1e7484.jpg";